module.exports = __webpack_public_path__ + "img/taxi-cars.30d700c.svg";